import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6821cd87"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.showSnackbar)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "snackbar",
          class: _normalizeClass(["snackbar", [_ctx.statusType, _ctx.showSnackbar ? 'show' : '']])
        }, [
          _createElementVNode("p", { innerHTML: _ctx.message }, null, 8, _hoisted_1),
          _createElementVNode("span", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.close()), ["prevent","stop"])),
            title: "Dismiss"
          }, _hoisted_3)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}